export class Cookies {
    closeButton = ".js-cookies-close";

    onClose = () => {
        this.node.hide();
    }

    constructor(node) {
        this.node = $(node);

        $(this.closeButton).on('click', this.onClose);
    }
}



// WEBPACK FOOTER //
// ./app/blocks/cookies/cookies.js